const cwsCustomSelect = () => {
  var change = new Event("change");
  var selects = document.querySelectorAll(".custom-select select");

  selects.forEach(function (select) {
    var title = select
      .closest(".custom-select")
      .querySelector(".custom-select__open span");

    if (select.options[select.selectedIndex] !== undefined) {
      title.innerHTML = select.options[select.selectedIndex].value;
    }
  });

  window.addEventListener("click", function (e) {
    var selectBoxesOpen = document.querySelectorAll(".custom-select__open");
    var selectBoxesDropdown = document.querySelectorAll(
      ".custom-select__dropdown"
    );

    selectBoxesOpen.forEach(function (select) {
      if (
        select.classList.contains("active") &&
        !e.target.closest(".custom-select")
      ) {
        select.classList.remove("active");
      }
    });

    selectBoxesDropdown.forEach(function (select) {
      if (
        select.classList.contains("active") &&
        !e.target.closest(".custom-select")
      ) {
        select.classList.remove("active");
      }
    });
  });

  document.addEventListener("click", function (e) {
    var target = e.target.closest(".custom-select__open");

    if (!target) return;

    var parent = e.target.closest(".custom-select");
    var dropdown = parent.querySelector(".custom-select__dropdown");
    var selectBoxes = document.querySelectorAll(".custom-select");
    var title = parent.querySelector(".custom-select__open span");
    var select = parent.querySelector("select");
    var dropdownLinks = parent.querySelectorAll("li");

    // target.classList.toggle("active");

    if (target.classList.contains("active")) {
      target.classList.remove("active");
      dropdown.classList.remove("active");
    } else {
      target.classList.add("active");
      dropdown.classList.add("active");
      selectBoxes.forEach(function (select) {
        select.classList.remove("active");
      });
    }

    if (select !== null) {
      title.innerHTML = select.options[select.selectedIndex].value;
      dropdownLinks.forEach(function (link) {
        if (link.dataset.customSelectBound === "true") return;

        link.addEventListener("click", function () {
          var val = link.getAttribute("data-value");
          var parent = link.closest(".custom-select");
          var dropdown = parent.querySelector(".custom-select__open");
          var open = parent.querySelector(".custom-select__dropdown");

          if (select.value === val) {
            dropdown.classList.remove("active");
            open.classList.remove("active");
            return;
          }

          select.value = val;
          link
            .closest("ul")
            .querySelector(".selected")
            .classList.remove("selected");
          link.classList.add("selected");
          var ev = document.createEvent("Event");
          ev.initEvent("change", true, false);
          select.dispatchEvent(ev);
          // select.dispatchEvent(change);
          title.innerHTML = select.value;
          dropdown.classList.remove("active");
          open.classList.remove("active");
        });

        link.dataset.customSelectBound = "true";
      });
    } else {
      dropdownLinks.forEach(function (link) {
        if (link.classList.contains("selected")) {
          title.innerHTML = link.textContent;
        }
      });
    }
  });
};

cwsCustomSelect();
